import { AttributeTypeENUM } from '../../enums/ProductEnums';
import { AttributeValue } from '../views/AttributeValue';
import { LocalizedText } from '../views/LocalizedText';
import {
  AttributeValueDTO,
  FlipValueDTO,
  MaterialValueDTO,
  ModelValueDTO,
  VariationValueDTO,
} from './AttributeValueDTO';
import { LocalizedTextDTO } from './LocalizedTextDTO';
import { ReceiptSettings } from './ProductBlueprintDTO';

export interface IAttribute {
  id: number | string;
  attributeValues: AttributeValueDTO[];
  defaultValue?: number | undefined;
  infoText: LocalizedTextDTO[];
  multiSelection: boolean;
  externalId: string;
  name: LocalizedTextDTO[];
  type: AttributeTypeENUM;
  isShown: boolean;
  builderData?: string;
  attributeIds?: number[];
  isGlobal: boolean;
  displayParameters?: string;
  receiptSettings?: ReceiptSettings;
}

export interface INumericChange extends IAttribute {
  step: number;
  max: number;
  min: number;
  unit: string;
  unitFactor: number;
}

export class AttributeDTO {
  id: number;
  attributeValues: AttributeValueDTO[];
  defaultValue?: number;
  infoText: LocalizedTextDTO[];
  multiSelection: boolean;
  externalId: string;
  name: LocalizedTextDTO[];
  type: AttributeTypeENUM;
  isShown: boolean;
  builderData?: string;
  attributeIds?: number[];
  isGlobal = false;
  displayParameters?: string;
  receiptSettings?: ReceiptSettings;

  constructor(
    id: number,
    attributeValues: AttributeValueDTO[],
    defaultValue: number | undefined,
    infoText: LocalizedTextDTO[],
    multiSelection: boolean,
    externalId: string,
    name: LocalizedTextDTO[],
    type: AttributeTypeENUM,
    isShown: boolean,
    builderData?: string,
    attributeIds?: number[],
    isGlobal = false,
    displayParameters?: string,
    receiptSettings?: ReceiptSettings,
  ) {
    this.id = id;
    this.attributeValues = attributeValues;
    this.defaultValue = defaultValue;
    this.infoText = infoText;
    this.multiSelection = multiSelection;
    this.externalId = externalId;
    this.name = name;
    this.type = type;
    this.isShown = isShown;
    this.builderData = builderData;
    this.attributeIds = attributeIds;
    this.isGlobal = isGlobal;
    this.displayParameters = displayParameters;
    this.receiptSettings = receiptSettings;
  }
}
export class VariationChangeDTO extends AttributeDTO {
  constructor(
    id: number,
    attributeValues: VariationValueDTO[],
    defaultValue: number | undefined,
    infoText: LocalizedTextDTO[],
    multiSelection: boolean,
    externalId: string,
    name: LocalizedTextDTO[],
    type: AttributeTypeENUM,
    isShown: boolean,
    builderData?: string,
    attributeIds?: number[],
    isGlobal?: boolean,
    displayParameters?: string,
  ) {
    super(
      id,
      attributeValues,
      defaultValue,
      infoText,
      multiSelection,
      externalId,
      name,
      type,
      isShown,
      builderData,
      attributeIds,
      isGlobal,
      displayParameters,
    );
  }
}
export class MaterialChangeDTO extends AttributeDTO {
  materialNames: string[] = [];
  absoluteTextureVector?: number[];
  constructor(
    id: number,
    attributeValues: MaterialValueDTO[],
    defaultValue: number | undefined,
    infoText: LocalizedTextDTO[],
    multiSelection: boolean,
    externalId: string,
    name: LocalizedTextDTO[],
    type: AttributeTypeENUM,
    isShown: boolean,
    materialNames: string[],
    builderData?: string,
    attributeIds?: number[],
    isGlobal?: boolean,
    displayParameters?: string,
    absoluteTextureVector?: number[],
  ) {
    super(
      id,
      attributeValues,
      defaultValue,
      infoText,
      multiSelection,
      externalId,
      name,
      type,
      isShown,
      builderData,
      attributeIds,
      isGlobal,
      displayParameters,
    );
    this.materialNames = materialNames;
    this.absoluteTextureVector = absoluteTextureVector;
  }
}

export class NumericChangeDTO extends AttributeDTO {
  step: number;
  max: number;
  min: number;
  unit: string;
  unitFactor: number;

  constructor(
    id: number,
    attributeValues: MaterialValueDTO[],
    defaultValue: number | undefined,
    infoText: LocalizedTextDTO[],
    multiSelection: boolean,
    externalId: string,
    name: LocalizedTextDTO[],
    type: AttributeTypeENUM,
    isShown: boolean,
    step: number,
    max: number,
    min: number,
    unit: string,
    unitFactor: number,
    builderData?: string,
    attributeIds?: number[],
    isGlobal?: boolean,
    displayParameters?: string,
  ) {
    super(
      id,
      attributeValues,
      defaultValue,
      infoText,
      multiSelection,
      externalId,
      name,
      type,
      isShown,
      builderData,
      attributeIds,
      isGlobal,
      displayParameters,
    );
    this.step = step;
    this.max = max;
    this.min = min;
    this.unit = unit;
    this.unitFactor = unitFactor;
  }
}

export class ModelChangeDTO extends AttributeDTO {
  visibilityChange: boolean;
  constructor(
    id: number,
    attributeValues: ModelValueDTO[],
    defaultValue: number | undefined,
    infoText: LocalizedTextDTO[],
    multiSelection: boolean,
    externalId: string,
    name: LocalizedTextDTO[],
    type: AttributeTypeENUM,
    isShown: boolean,
    visibilityChange = true,
    builderData?: string,
    attributeIds?: number[],
    isGlobal?: boolean,
    displayParameters?: string,
  ) {
    super(
      id,
      attributeValues,
      defaultValue,
      infoText,
      multiSelection,
      externalId,
      name,
      type,
      isShown,
      builderData,
      attributeIds,
      isGlobal,
      displayParameters,
    );
    this.visibilityChange = visibilityChange;
  }
}

export class FlipChangeDTO extends AttributeDTO {
  constructor(
    id: number,
    attributeValues: FlipValueDTO[],
    defaultValue: number | undefined,
    infoText: LocalizedTextDTO[],
    multiSelection: boolean,
    externalId: string,
    name: LocalizedTextDTO[],
    type: AttributeTypeENUM,
    isShown: boolean,
    builderData?: string,
  ) {
    super(id, attributeValues, defaultValue, infoText, multiSelection, externalId, name, type, isShown, builderData);
  }
}
